/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.3.2
 * @since 1.0.1
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';
import * as skeleton from '../skeletonConfiguration';
import { ISkeletonStyled } from '../skeletonTypes';
import { LoaderAnimation } from './SkeletonStyled';

export const SkeletonButtonStyled = styled(LoaderAnimation).attrs({
    className: 'skeleton__button',
})<ISkeletonStyled>`
    width: ${skeleton.width};
    height: ${skeleton.height};
    border-radius: ${skeleton.buttonBorderRadius};
    animation-name: ${skeleton.animationName};
    animation-duration: ${skeleton.animationDuration};
    background: ${colors.skeletonBgLoader};
`;
